<template>
    <section>
        <div class="text-gray-mobly54 text-3xl leading-tight mt-3 mb-3 md:text-left">
            Meus Pedidos
        </div>
        <div class="flex flex-nowrap justify-start items-center border-b border-gray-200 mb-6 gap-x-1 sm:gap-x-4 md:gap-x-12">
            <button
                type="button"
                id="in-progress-button"
                class="pb-2 px-1 md:px-4 text-lg md:text-lg font-normal cursor-pointer focus:outline-none whitespace-nowrap text-center"
                :class="{ 'text-orange-mobly border-b-2 border-orange-mobly': activeTab === 'inProgress', 'text-purple-900': activeTab !== 'inProgress' }"
                @click="setActiveTab('inProgress')" :disabled="loading">
                Em andamento
            </button>
            <button
                type="button"
                id="finished-button"
                class="pb-2 px-1 md:px-4 text-lg md:text-lg font-normal cursor-pointer focus:outline-none whitespace-nowrap text-center"
                :class="{ 'text-orange-mobly border-b-2 border-orange-mobly': activeTab === 'finished', 'text-purple-900': activeTab !== 'finished' }"
                @click="setActiveTab('finished')" :disabled="loading">
                Finalizados
            </button>
        </div>
        <spinner :loading="loading" />

        <div v-if="error != null && !loading">
            <div class="mt-5">
                <h4 v-if="error.open" class="text-center text-yellow-500">
                    {{ error.open }}
                    <span class="cursor-pointer text-purple-mobly" :disabled="loading"
                        @click="changeStatusOrder('closed')" v-html="'Veja seus pedidos fechados!'"></span>
                </h4>
                <h4 v-if="error && !error.open" class="text-center" v-html="error"></h4>
            </div>
        </div>
        <div :class="{ 'opacity-50': loading }" 
        class="mt-6 md:grid md:grid-cols-2 md:gap-5 transition-opacity duration-300"
        >
        <router-link
            v-for="item in list" :key="item.orderNr"
            :id="`order-link-${item.orderNr}`"
            :to="{ path: `meus-pedidos/pedido/${item.orderNr}` }"
            class="block rounded border-1 border-transparent hover:border-orange-mobly transition duration-200 ease-in-out text-inherit hover:no-underline mb-2 sm:mb-0">
            <order-box :item-list="item"></order-box>
        </router-link>
        </div>
        <div class="flex justify-center md:justify-end mt-8 mb-8 md:mr-18">
            <Pagination
                :show-pagination="shouldShowPagination"
                :mobile-breakpoint="768"
                @prev-page="goToPrevPage"
                @next-page="goToNextPage"
                @go-to-page="goToPage"
            />
        </div>
        <div class="flex justify-center md:justify-start mt-2 md:mt-12 md:ml-18 mb-8">
            <a :href="env.VUE_APP_URL + env.VUE_APP_MENU_PANEL"
                class="font-semibold text-base text-purple-900 hover:text-purple-700 hover:no-underline">
                Voltar para Minha conta
            </a>
        </div>
    </section>
</template>

<script>
import OrderBox from './Box'
import namespace from '../../vuex/namespace'
import { mapState, mapGetters, mapActions } from 'vuex'
import Spinner from '../Spinner/Spinner'
import Pagination from '../Pagination/Pagination'

export default {
    name: 'OrdersList',
    data: function () {
        return {
            activeTab: 'inProgress'
        }
    },
    computed: {
        ...mapState(namespace.ORDERS, [
            'list',
            'error',
            'loading',
            'status',
            'pagination'
        ]),
        ...mapGetters(namespace.ORDERS, [
            'getPage'
        ]),
        ...mapState(namespace.ROUTE, [
            'params'
        ]),
        shouldShowPagination() {
            return this.list && this.list.length > 0 && this.pagination.listPage && this.pagination.listPage.length > 1
        },
        env: function () {
            return process.env
        }
    },
    components: {
        OrderBox,
        Spinner,
        Pagination
    },
    watch: {
    '$route.query': {
      handler (query) {
        let filterFromUrl = query.filter
        let pageFromUrl = query.page        
        let initialActiveTab = 'inProgress'

        if (filterFromUrl === 'closed') {
            initialActiveTab = 'finished'
        } else {
            initialActiveTab = 'inProgress'
        }
        this.activeTab = initialActiveTab

        this.changeStatus(filterFromUrl)
        this.setPage(pageFromUrl || 1)
        this.loadOrders()
        
      },
      immediate: true
    }
  },
    methods: {
        ...mapActions(namespace.ORDERS, [
            'loadOrders',
            'changeStatusOrder',
            'setPage',
            'changeStatus',
            'loadNextPage',
            'loadPrevPage'
        ]),
        getMyTicketUrl() {
            window.open(`${process.env.VUE_APP_CS_EXTERNAL_URL}/redirect-my-tickets`, '_blank')
        },
        setActiveTab(tab) {
            let filterMap = {
                inProgress: 'opened',
                finished: 'closed'
            }
            let apiFilter = filterMap[tab] || ''
            this.$router.push({ query: { page: 1, filter: apiFilter } }).catch(() => { })
        },
        goToPrevPage() {
            let newPage = this.pagination.page - 1
            this.updateRoute(newPage)
        },
        goToNextPage() {
            let newPage = this.pagination.page + 1
            this.updateRoute(newPage)
        },
        goToPage(page) {
            this.updateRoute(page)
        },
        updateRoute(page) {
            this.scroll()
            this.$router.push({
                query: { 
                    page: page, 
                    filter: this.$route.query.filter || 'opened'
                } 
            }).catch(() => {})
        },
        scroll() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>